import axios from 'axios';
import Vue from 'vue';

const errorResponseHandler = (error) => {
    if (!error.response) return console.error(error);

    if (
        Object.prototype.hasOwnProperty.call(error.config, 'errorHandle') &&
        error.config.errorHandle === false
    ) {
        return Promise.reject(error);
    }

    const {
        response: {
            data: { errors, message },
        },
    } = error;

    // if has response show the error
    if (errors) {
        Object.keys(errors).forEach((key) => {
            Vue.notify({
                title: errors[key][0],
                type: 'danger',
                duration: 3000,
            });
        });
    } else if (message.text !== undefined) {
        Vue.notify({
            title: message.title,
            text: message.text,
            type: message.type !== undefined ? message.type : 'danger',
            duration: 3000,
        });
    } else if (message) {
        Vue.notify({
            title: message,
            type: 'danger',
            duration: 3000,
        });
    }

    if (error || message) return Promise.reject(error || message);

    return false;
};

axios.interceptors.response.use(response => response, errorResponseHandler);

export default {
    init() {
        axios.defaults.headers.common['X-CSRF-TOKEN'] =
            window.Laravel.csrfToken;
        axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    },
};
